export function removePublicDir(source: string) {
  const match = source.match(/^\s*publicDir\s*:\s*['"](\.\/)?static\/?['"]\s*,?$/m);

  if (match?.index != null) {
    return source.slice(0, match.index) + source.slice(match.index + match[0].length + 1);
  }

  return source;
}
